// import React from "react";
// import { useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";

// const LeadsDataPage = () => {
//   const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
//   const location = useLocation();
//   const leadsData = location.state?.leadsData || []; // Retrieve passed data or fallback to an empty array

//   // Extract headers dynamically based on the first item in leadsData
//   const headers = leadsData.length > 0 ? Object.keys(leadsData[0]) : [];

//   return (
//     <div
//       className={`flex-1 bg-white ${
//         isSideBarOpen ? "ml-80" : "ml-20"
//       } min-h-screen`}
//     >
//       <div className="p-6 space-y-6">
//         <h2 className="text-2xl font-bold">Leads Data</h2>
//         {leadsData.length > 0 ? (
//           <table className="min-w-full bg-white border border-gray-300 rounded-md">
//             <thead>
//               <tr>
//                 {/* Render headers dynamically */}
//                 {headers.map((header, index) => (
//                   <th
//                     key={index}
//                     className="px-4 py-2 text-left border-b capitalize"
//                   >
//                     {header.replace(/_/g, " ")} {/* Replace underscores for readability */}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {/* Render rows dynamically */}
//               {leadsData.map((row, rowIndex) => (
//                 <tr key={rowIndex}>
//                   {headers.map((header, colIndex) => (
//                     <td key={colIndex} className="px-4 py-2 border-b">
//                       {row[header]}
//                     </td>
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         ) : (
//           <p>No data available.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default LeadsDataPage;

import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const LeadsDataPage = () => {
  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
  const location = useLocation();
  const leadsData = location.state?.leadsData || []; // Retrieve passed data or fallback to an empty array

  // Define the headers you want to display
  const headers = ["id", "name", "phone", "email", "created_at", "created_by"];

  return (
    <div
      className={`flex-1 bg-white ${
        isSideBarOpen ? "ml-80" : "ml-20"
      } min-h-screen`}
    >
      <div className="p-6 space-y-6">
        <h2 className="text-4xl font-semibold text-gray-800 mb-6">
          Leads Data
        </h2>
        {leadsData.length > 0 ? (
          <div className="overflow-x-auto bg-white rounded-lg shadow-md max-w-8xl mx-auto">
            <table className="min-w-full bg-white text-gray-700">
              <thead className="bg-gray-100 text-lg font-semibold text-gray-600">
                <tr>
                  {/* Render only the specific headers */}
                  {headers.map((header, index) => (
                    <th
                      key={index}
                      className="px-8 py-4 text-left border-b border-gray-200 uppercase tracking-wider"
                    >
                      {header.replace(/_/g, " ")}{" "}
                      {/* Replace underscores for readability */}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {/* Render only the specific data for the selected headers */}
                {leadsData.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className="hover:bg-gray-50 transition-colors duration-300"
                  >
                    {headers.map((header, colIndex) => (
                      <td
                        key={colIndex}
                        className="px-8 py-5 border-b border-gray-200 text-base"
                      >
                        {row[header] || "N/A"}{" "}
                        {/* Display the data based on the selected headers */}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-center text-gray-500">No data available.</p>
        )}
      </div>
    </div>
  );
};

export default LeadsDataPage;
